// Copied from the src/pages/globalpedia/pages/StudioMonthlyReport/LiveTitle/pages/LiveVisualization/component/MetricsCardGP/index.tsx

import React from 'react';
import { useIntl } from 'umi';
import './index.scss';
import MetricsCardWrap from '@sg/components/MetricsCardWrap';
import MetricsCardValue, { IMetricsCardValue } from '@/pages/dashboard/components/MetricsCardValue';
import MetricsCardDod, { IMetricsDod } from '@/pages/dashboard/components/MetricsCardDod';

interface IMetricsCardWrap {
  // 类名
  className?: string;
  overlayClassName?: string;
  // 样式
  style?: React.CSSProperties;
  // 中英文标题
  titleEn: string;
  titleCn: string;
  // 中英文副标题
  subtitleEn?: string;
  subtitleCn?: string;
  // 跳转链接
  link?: string;
  // 标题旁图标(SvgIcon引入)
  icon?: string;
  // 标题旁图标（getImg项目图标引入）
  titleIcon?: string;
  // 标题旁图片地址
  imgUrl?: string;
  // 是否开启icon的info提示（与标题hover的提示互斥）
  isIconTips?: boolean;
  // 中英文指标注释
  tipsEn?: string;
  tipsCn?: string;
  definition?: string;
  source?: string;
  updateTime?: string;
  // 头部组件
  contentHeader?: React.ReactNode;
  // 尾部组件
  contentFooter?: React.ReactNode;
  metricData?: any[];
}

interface IMetricsCardDod {
  // 类名
  dodClassName?: string;
  // 样式
  dodStyle?: React.CSSProperties;
  dodData: IMetricsDod[];
}
interface IMetricsCard extends IMetricsCardWrap, IMetricsCardValue, IMetricsCardDod {
  valueStyle?: React.CSSProperties;
  metricsChart?: JSX.Element;
  valueClassName?: string;
  children?: JSX.Element;
}


const MetricsCard = (props: IMetricsCard) => {
  const { titleEn, titleCn, subtitleEn, subtitleCn, icon, titleIcon, imgUrl, link, tipsEn, tipsCn, definition, source, updateTime, isIconTips, contentHeader, contentFooter, metricsChart, valueClassName, valueStyle, value, formatRule, titleFormatRule, emptyValue, preUnit, endUnit, dodClassName, dodStyle, dodData, style, className, overlayClassName, children, metricData } = props;
  const { formatMessage } = useIntl();

  const checkIsEmpty = () => {
    const isDodEmpty = dodData.every(item => item.value === '-' || !item.value);
    const isValueEmpty = !value || value === '-';
    const isMetricDataEmpty = !metricData || metricData?.every(item => !item?.metrics?.current?.value || item?.metrics?.current?.value === '-');
    return isDodEmpty && isValueEmpty && isMetricDataEmpty;
  };

  return (
    <div className='dbs-metrics-card'>
      <MetricsCardWrap
        titleCn={titleCn}
        titleEn={titleEn}
        className={className}
        overlayClassName={overlayClassName}
        style={style}
        link={link}
        tipsEn={tipsEn}
        tipsCn={tipsCn}
        definition={definition}
        source={source}
        updateTime={updateTime}
        icon={icon}
        titleIcon={titleIcon}
        imgUrl={imgUrl}
        isIconTips={isIconTips}
        subtitleEn={subtitleEn}
        subtitleCn={subtitleCn}
        contentHeader={contentHeader}
        contentFooter={contentFooter}
      >
        <div className={`dbd-metrics-card__flex dbd-metrics-card__row dbs-metrics-card__row`}>
          {
            checkIsEmpty()
              ? <div className='dbd-metrics-card__empty'>{formatMessage({ id: 'dbs_empty_text' })}</div>
              : <>
                <div className={`dbd-metrics-card__flex`}>
                  <MetricsCardValue
                    className={valueClassName}
                    style={valueStyle}
                    value={value}
                    formatRule={formatRule}
                    titleFormatRule={titleFormatRule}
                    emptyValue={emptyValue}
                    preUnit={preUnit}
                    endUnit={endUnit}
                  />
                  <MetricsCardDod
                    className={dodClassName}
                    style={dodStyle}
                    data={dodData}
                  />
                </div>
                {
                  metricsChart && metricsChart
                }
              </>
          }
        </div>
        {
          children && children
        }
      </MetricsCardWrap>
    </div>
  );
};

export default MetricsCard;
